import { render } from "./CustomPricing.vue?vue&type=template&id=08b6524f"
import script from "./CustomPricing.vue?vue&type=script&lang=js"
export * from "./CustomPricing.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-deploy-to-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__